import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

export const typeRights = Object.freeze([
  {
    id: '0',
    value: 'uso interno',
  },
  {
    id: '1',
    value: 'diritti di segreteria',
  },
  {
    id: '2',
    value: 'diritti di stato civile',
  },
  {
    id: '3',
    value: 'diritti fissi',
  },
]);

interface TypeRightsListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const TypeRightsListComponent = ({
  disabled,
  onChange,
  value,
  error,
}: TypeRightsListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="type-rights-label">
        Tipo diritti
      </InputLabel>
      <PmiSelect
        labelId="type-rights-label"
        id="type-rights"
        name="type-rights"
        value={value}
        label="Tipo diritti"
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {typeRights.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeRightsListComponent.displayName = 'List type Rights component';

const TypeRightsList = memo(TypeRightsListComponent);

export default TypeRightsList as typeof TypeRightsListComponent;
